import React, {
  useEffect,
  useState,
  useMemo
} from 'react';
import Form, { GroupItem, SimpleItem, Label } from 'devextreme-react/form';
import { LoadPanel } from 'devextreme-react/load-panel';
import { formatMessage } from 'devextreme/localization';
import ScrollView from 'devextreme-react/scroll-view';
import SplitterLayout from 'react-splitter-layout';
import WorkingDetailing from './WorkingDetailing';
import columnDataGrid from './columnDataGrid';
import columnDataGridConsignment from './columnDataGridConsignment';
import columnDataGridRecycling from './columnDataGridRecycling';

import style from './infodetails.module.scss';

const InfoDetails = ({
  pieceInfoReducer: {
    loading,
    details
  },
  pieceNumId
}) => {
  const [isConsignment, setIsConsignment] = useState(0);
  const [plantId, setPlantId] = useState(0);
  const [checkedTablistItems, setCheckedTablistItems] = useState([]);
  useEffect(() => {
    if (details) {
      setIsConsignment(details.plantShippingType);
      setPlantId(details.plantId);
    }
  }, [details]);

  const checkedListItemsIsSameWithCurrent = useMemo(
    () =>
      !!(checkedTablistItems.length && checkedTablistItems.length > 1
        && checkedTablistItems.some((id) => String(id) === String(pieceNumId))),
    [checkedTablistItems, pieceNumId]
  );

  useEffect(() => {
    const checkedItems = JSON.parse(localStorage.getItem('checkedItems'))?.map((item) => String(item.pieceNumId)) || [];
    if (checkedItems && checkedItems.length) {
      setCheckedTablistItems(checkedItems);
    }
  }, []);

  const renderInfo = useMemo(() => {
    if (isConsignment === 1) {
      return (
        <Form colCount={3}
              id="formInfoDetails"
              formData={details}
        >
          <GroupItem caption={formatMessage('textInfoTab').pieceInformation}>
            {
              columnDataGridConsignment.filter((item) => item.groupItem === 1).map((item) => (
                <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                            dataField={item.dataField}
                            editorType={item.editorType}
                            key={item.dataField}
                >
                  <Label text={item.caption && formatMessage('textTable').consignment[item.dataField]} />
                </SimpleItem>
              ))
            }
          </GroupItem>
          <GroupItem caption={formatMessage('textInfoTab').consignee}>
            {
              columnDataGridConsignment.filter((item) => item.groupItem === 2).map((item) => (
                <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                            dataField={item.dataField}
                            editorType={item.editorType}
                            key={item.dataField}
                >
                  <Label text={item.caption && formatMessage('textTable').consignment[item.dataField]} />
                </SimpleItem>
              ))
            }
          </GroupItem>
          <GroupItem caption={formatMessage('textInfoTab').orderData}>
            {
              columnDataGridConsignment.filter((item) => item.groupItem === 3).map((item) => (
                <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                            dataField={item.dataField}
                            editorType={item.editorType}
                            key={item.dataField}
                >
                  <Label text={item.caption && formatMessage('textTable').consignment[item.dataField]} />
                </SimpleItem>
              ))
            }
          </GroupItem>
        </Form>
      );
    }
    if (isConsignment === 2) {
      return (
        <Form colCount={3}
              id="formInfoDetails"
              formData={details}
        >
          <GroupItem caption={formatMessage('textInfoTab').pieceInformation}>
            {
              columnDataGridRecycling.filter((item) => item.groupItem === 1).map((item) => (
                <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                            dataField={item.dataField}
                            editorType={item.editorType}
                            key={item.dataField}
                >
                  <Label text={item.caption && formatMessage('textTable').consignment[item.dataField]} />
                </SimpleItem>
              ))
            }
          </GroupItem>
          <GroupItem caption={formatMessage('textInfoTab').consignee}>
            {
              columnDataGridRecycling.filter((item) => item.groupItem === 2).map((item) => (
                <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                            dataField={item.dataField}
                            editorType={item.editorType}
                            key={item.dataField}
                >
                  <Label text={item.caption && formatMessage('textTable').consignment[item.dataField]} />
                </SimpleItem>
              ))
            }
          </GroupItem>
          <GroupItem caption={formatMessage('textInfoTab').orderData}>
            {
              columnDataGridRecycling.filter((item) => item.groupItem === 3).map((item) => (
                <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                            dataField={item.dataField}
                            editorType={item.editorType}
                            key={item.dataField}
                >
                  <Label text={item.caption && formatMessage('textTable').consignment[item.dataField]} />
                </SimpleItem>
              ))
            }
          </GroupItem>
        </Form>
      );
    }
    return (
      <Form colCount={3}
            id="formInfoDetails"
            formData={details}
      >
        <GroupItem caption={formatMessage('textInfoTab').pieceInformation}>
          {
            columnDataGrid.filter((item) => item.groupItem === 1).map((item) => (
              <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                          editorType={item.editorType}
                          dataField={item.dataField}
                          key={item.dataField}
              >
                <Label text={item.caption && formatMessage('textTable')[item.dataField]} />
              </SimpleItem>
            ))
          }
        </GroupItem>
        <GroupItem caption={formatMessage('textInfoTab').consignee}>
          {
            columnDataGrid.filter((item) => item.groupItem === 2).map((item) => (
              <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                          dataField={item.dataField}
                          editorType={item.editorType}
                          key={item.dataField}
              >
                <Label text={item.caption && formatMessage('textTable')[item.dataField]} />
              </SimpleItem>
            ))
          }
        </GroupItem>
        <GroupItem caption={formatMessage('textInfoTab').orderData}>
          {
            columnDataGrid.filter((item) => item.groupItem === 3).map((item) => (
              <SimpleItem editorOptions={{ stylingMode: 'filled' }}
                          dataField={item.dataField}
                          editorType={item.editorType}
                          key={item.dataField}
              >
                <Label text={item.caption && formatMessage('textTable')[item.dataField]} />
              </SimpleItem>
            ))
          }
        </GroupItem>
      </Form>
    );
  }, [details, isConsignment]);

  return (
    <ScrollView className={style.main}>
      <SplitterLayout percentage={checkedListItemsIsSameWithCurrent} secondaryMinSize={checkedListItemsIsSameWithCurrent ? 100 : undefined}>
        <ScrollView showScrollbar="always"
                    width="100%"
        >
          { renderInfo }
        </ScrollView>
        <ScrollView showScrollbar="always"
                    width="100%"
        >
          <WorkingDetailing pieceNumId={pieceNumId}
                            plantId={plantId} />
        </ScrollView>
      </SplitterLayout>
      <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                 showPane
                 shading={false}
                 showIndicator
                 visible={loading}
      />
    </ScrollView>
  );
};

export default InfoDetails;
